/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    BodyUpdateShowApiV1ShowsShowPut,
    HTTPValidationError,
    ListShowAdminResponse,
    ListShowResponse,
    ResponseGetShowApiV1ShowsShowGet,
    Search,
    ShowAdminModel,
    ShowCreateModel,
} from '../models/index';
import {
    BodyUpdateShowApiV1ShowsShowPutFromJSON,
    BodyUpdateShowApiV1ShowsShowPutToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ListShowAdminResponseFromJSON,
    ListShowAdminResponseToJSON,
    ListShowResponseFromJSON,
    ListShowResponseToJSON,
    ResponseGetShowApiV1ShowsShowGetFromJSON,
    ResponseGetShowApiV1ShowsShowGetToJSON,
    SearchFromJSON,
    SearchToJSON,
    ShowAdminModelFromJSON,
    ShowAdminModelToJSON,
    ShowCreateModelFromJSON,
    ShowCreateModelToJSON,
} from '../models/index';

export interface ArchiveShowApiV1ShowsArchivePutRequest {
    id: string;
}

export interface CreateShowApiV1ShowsShowPostRequest {
    showCreateModel: ShowCreateModel;
}

export interface DeleteShowApiV1ShowsShowDeleteRequest {
    id: string;
}

export interface GetArchivedShowsApiV1ShowsArchivedGetRequest {
    search?: Search;
    limit?: number;
    offset?: number;
}

export interface GetShowAdminApiV1ShowsAdminShowGetRequest {
    id: string;
}

export interface GetShowApiV1ShowsShowGetRequest {
    id: string;
}

export interface GetShowsAdminApiV1ShowsAdminGetRequest {
    limit?: number;
    offset?: number;
}

export interface GetShowsApiV1ShowsGetRequest {
    search?: string;
    limit?: number;
    offset?: number;
}

export interface UpdateShowApiV1ShowsShowPutRequest {
    id: string;
    bodyUpdateShowApiV1ShowsShowPut?: BodyUpdateShowApiV1ShowsShowPut;
}

/**
 *
 */
export class ShowApi extends runtime.BaseAPI {
    /**
     * Archive a show.
     * Archive Show
     */
    async archiveShowApiV1ShowsArchivePutRaw(
        requestParameters: ArchiveShowApiV1ShowsArchivePutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ShowAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling archiveShowApiV1ShowsArchivePut().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/shows/archive`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ShowAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Archive a show.
     * Archive Show
     */
    async archiveShowApiV1ShowsArchivePut(
        requestParameters: ArchiveShowApiV1ShowsArchivePutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ShowAdminModel> {
        const response = await this.archiveShowApiV1ShowsArchivePutRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Create a show.
     * Create Show
     */
    async createShowApiV1ShowsShowPostRaw(
        requestParameters: CreateShowApiV1ShowsShowPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ShowAdminModel>> {
        if (requestParameters['showCreateModel'] == null) {
            throw new runtime.RequiredError(
                'showCreateModel',
                'Required parameter "showCreateModel" was null or undefined when calling createShowApiV1ShowsShowPost().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/shows/show`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ShowCreateModelToJSON(requestParameters['showCreateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ShowAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Create a show.
     * Create Show
     */
    async createShowApiV1ShowsShowPost(
        requestParameters: CreateShowApiV1ShowsShowPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ShowAdminModel> {
        const response = await this.createShowApiV1ShowsShowPostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete a show.
     * Delete Show
     */
    async deleteShowApiV1ShowsShowDeleteRaw(
        requestParameters: DeleteShowApiV1ShowsShowDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteShowApiV1ShowsShowDelete().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/shows/show`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a show.
     * Delete Show
     */
    async deleteShowApiV1ShowsShowDelete(
        requestParameters: DeleteShowApiV1ShowsShowDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.deleteShowApiV1ShowsShowDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve archived shows based on the provided search criteria.
     * Get Archived Shows
     */
    async getArchivedShowsApiV1ShowsArchivedGetRaw(
        requestParameters: GetArchivedShowsApiV1ShowsArchivedGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListShowResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/shows/archived`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListShowResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve archived shows based on the provided search criteria.
     * Get Archived Shows
     */
    async getArchivedShowsApiV1ShowsArchivedGet(
        requestParameters: GetArchivedShowsApiV1ShowsArchivedGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListShowResponse> {
        const response = await this.getArchivedShowsApiV1ShowsArchivedGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve a show for admin view.
     * Get Show Admin
     */
    async getShowAdminApiV1ShowsAdminShowGetRaw(
        requestParameters: GetShowAdminApiV1ShowsAdminShowGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ShowAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getShowAdminApiV1ShowsAdminShowGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/shows/admin/show`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ShowAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve a show for admin view.
     * Get Show Admin
     */
    async getShowAdminApiV1ShowsAdminShowGet(
        requestParameters: GetShowAdminApiV1ShowsAdminShowGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ShowAdminModel> {
        const response = await this.getShowAdminApiV1ShowsAdminShowGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve a show.
     * Get Show
     */
    async getShowApiV1ShowsShowGetRaw(
        requestParameters: GetShowApiV1ShowsShowGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ResponseGetShowApiV1ShowsShowGet>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getShowApiV1ShowsShowGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/shows/show`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ResponseGetShowApiV1ShowsShowGetFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve a show.
     * Get Show
     */
    async getShowApiV1ShowsShowGet(
        requestParameters: GetShowApiV1ShowsShowGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ResponseGetShowApiV1ShowsShowGet> {
        const response = await this.getShowApiV1ShowsShowGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve shows for admin view.
     * Get Shows Admin
     */
    async getShowsAdminApiV1ShowsAdminGetRaw(
        requestParameters: GetShowsAdminApiV1ShowsAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListShowAdminResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/shows/admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListShowAdminResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve shows for admin view.
     * Get Shows Admin
     */
    async getShowsAdminApiV1ShowsAdminGet(
        requestParameters: GetShowsAdminApiV1ShowsAdminGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListShowAdminResponse> {
        const response = await this.getShowsAdminApiV1ShowsAdminGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve shows based on the provided search criteria.
     * Get Shows
     */
    async getShowsApiV1ShowsGetRaw(
        requestParameters: GetShowsApiV1ShowsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListShowResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/shows/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListShowResponseFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve shows based on the provided search criteria.
     * Get Shows
     */
    async getShowsApiV1ShowsGet(
        requestParameters: GetShowsApiV1ShowsGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListShowResponse> {
        const response = await this.getShowsApiV1ShowsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a show.
     * Update Show
     */
    async updateShowApiV1ShowsShowPutRaw(
        requestParameters: UpdateShowApiV1ShowsShowPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ShowAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateShowApiV1ShowsShowPut().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/shows/show`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: BodyUpdateShowApiV1ShowsShowPutToJSON(
                    requestParameters['bodyUpdateShowApiV1ShowsShowPut'],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ShowAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Update a show.
     * Update Show
     */
    async updateShowApiV1ShowsShowPut(
        requestParameters: UpdateShowApiV1ShowsShowPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ShowAdminModel> {
        const response = await this.updateShowApiV1ShowsShowPutRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
